import { css } from 'styled-components'

export const TextWrapper = css`
  ${(props) =>
    css`
      text-align: ${props.textAlignment};
    `}
`

export const visibleScrollBar = css`
  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`

export const BackgroundImage = css`
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
`
export const LinkWrapper = css`
  :hover {
    color: unset;
  }
`
/*  Resetting browser defaults * */
export const RichText = css`
  ul,
  ol {
    padding: 0 0 0 40px;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
`

export const NectarHeading = css`
  ${(props) =>
    props.theme.channel === 'nectar' &&
    css`
      color: ${props.theme.color.palette['purple-90']};
    `}
`

export const dropShadowCSS = css`
  ${(props) =>
    props.dropShadow &&
    css`
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.15);
    `}
`

export const marginBottomCSS = css`
  margin-bottom: ${(props) => props.theme.size.spacing.md};
`
